<template>
  <div class="component-wrapper secondary d-flex flex-column">
    <div
      v-if="loader"
      class="d-flex flex-column align-center justify-center flex-grow-1"
      style="height: 500px"
    >
      <v-progress-circular indeterminate color="primary lighten-1" size="60">
      </v-progress-circular>
    </div>

    <div
      class="d-flex justify-center flex-row flex-wrap px-1 mt-4"
      style="padding-bottom: 64px"
      v-else-if="!loader && routes.length > 0"
    >
      <v-card
        class="white mb-4"
        width="300"
        min-height="200"
        v-for="(route, i) in routes"
        :key="i"
      >
        <v-carousel
          :show-arrows="false"
          height="150"
          :cycle="true"
          :interval="3000"
          hide-delimiters
        >
          <v-carousel-item
            v-for="(poi, i) in route.path_pois"
            :key="i + route.id"
            height="150"
            cover
            :src="`https://efales.mobics.gr/${poi.poi.main_image}`"
            @click="$router.push(`/routes/${route.id}`)"
          ></v-carousel-item>
        </v-carousel>

        <div
          class="body-1 px-2 pt-2 mb-1 secondary--text font-weight-bold"
          @click="$router.push(`/routes/${route.id}`)"
        >
          {{ route.name }}
        </div>
      </v-card>
    </div>
    <div v-if="routes.length == 0 && !loader" class="white--text pa-2">
      {{ $t("general.nodata") }}
    </div>

    <v-bottom-sheet
      v-model="sheet"
      inset
      style="position: relative"
      scrollable
      v-if="!loader"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="filters_button" color="primary" fab dark medium>
          <v-icon color="secondary" v-bind="attrs" v-on="on"
            >mdi-tune-vertical</v-icon
          >
        </v-btn>
      </template>
      <div class="d-flex flex-column white">
        <div class="d-flex flex-column px-4 pt-6">
          <div class="d-flex">
            <div class="text-h5 font-weight-bold" style="width: 100%">
              {{ $t("general.filters_label") }}
            </div>
          </div>

          <v-divider class="my-4" style="width: 100%"></v-divider>
        </div>

        <v-expansion-panels flat :value="[0, 1, 2]" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header class="white body-1 font-weight-bold">
              {{ $t("general.categories_label") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="white">
              <div class="white">
                <div
                  v-for="(category, i) in categories"
                  :key="i + category.id"
                  @click="filters.category = category.id"
                  class="mb-4"
                >
                  <span
                    :class="
                      filters.category && filters.category == category.id
                        ? 'font-weight-bold'
                        : 'font-weight-regular'
                    "
                    class="body-1 d-flex align-center"
                  >
                    <span class="mr-auto">
                      {{ category.name }}
                    </span>
                    <v-icon
                      v-if="filters.category && filters.category == category.id"
                      color="brick"
                    >
                      mdi-check
                    </v-icon>
                  </span>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header class="white font-weight-bold body-1">
              {{ $t("general.pois_label") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="white">
              <v-select
                color="brick"
                v-model="selectedPoi"
                hide-details
                class="mb-2 px-4 ml-auto mr-auto"
                outlined
                solo
                :label="$t('general.pois_label')"
                :items="pois"
                item-text="name"
                item-value="id"
                clearable
                style="width: 325px"
              >
              </v-select>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header class="white font-weight-bold body-1">
              {{ $t("general.distance_label") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="white">
              <v-slider
                v-model="distance"
                color="brick"
                track-color="brick"
                class="px-4 mt-10"
                max="200"
                min="1"
                thumb-label="always"
                thumb-color="brick"
                hide-details
                label=""
                thumb-size="20"
              >
                <template v-slot:label>
                  <div class="secondary--text"></div>
                </template>
              </v-slider>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-btn
          class="mt-auto ml-auto mr-4 mb-4 brick white--text"
          style="text-transform: none"
          @click="filterApply"
        >
          Apply
        </v-btn>
      </div>
    </v-bottom-sheet>
  </div>
</template>
  
<script>
import axios from "axios";
import { mapMutations } from "vuex";
import { decodeEntities } from "../../utils/decodeEntities";

export default {
  async created() {
    this.setFilters({
      category: null,
    });
    await this.getRoutes();

    const pois = await axios.get(`${process.env.VUE_APP_BASE_URL}/pois`);

    const categories = await axios.get(
      `${process.env.VUE_APP_BASE_URL}/path-categories`
    );

    this.categories = categories.data;
    this.pois = pois.data;
  },

  data() {
    return {
      showFilters: false,
      loader: false,
      routes: [],
      sheet: false,

      categories: [],
      pois: [],
      selectedPoi: null,
      distance: null,
    };
  },

  computed: {
    filters: {
      get() {
        return this.$store.state.base.filters;
      },
      set(newValue) {
        this.setFilters(newValue);
      },
    },
  },

  methods: {
    ...mapMutations(["setFilters"]),

    decodeEntities(text) {
      return decodeEntities(text);
    },

    async getRoutes() {
      try {
        this.loader = true;

        const routes = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/paths`,
          {
            params: {
              area: this.filters.island,
              category:
                this.filters.category != 17 ? this.filters.category : null,
            },
          }
        );

        this.routes = routes.data;

        this.loader = false;
        //todo -> add category query param
      } catch (e) {
        this.loader = false;
        console.log(e);
      }
    },

    async filterApply() {
      try {
        this.loader = true;
        this.routes = [];
        const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/paths`, {
          params: {
            category: this.filters.category,
            distance: this.distance,
            starting_poi: this.selectedPoi,
          },
        });

        this.routes = res.data;

        this.loader = false;

        this.sheet = false;
        console.log(this.routes, "routes");
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
  
  <style  lang="scss">
.filters_button {
  position: fixed;
  bottom: 40px;
  right: 30px;
}

.v-list .v-list-item--active {
  background-color: var(--v-brick-base) !important;
}
.v-list .v-list-item--active .v-list-item__title {
  color: white !important;
}
</style>